module.exports = __webpack_public_path__ + "img/InventoryHome.d29845c6.svg";